import { Button, Table, TableColumns, TableColumnWidth, TableData, TablePreferences, Modal, ButtonGroup, IconWarning, IconRestore, IconCamera, SelectOption, Select } from "@veneer/core";
import { useCallback, useEffect, useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import SimpleMessageModal from "../../components/Modals/SimpleMessageModal";
import { IAppointmentDto } from "../../models/dto/agendaApi/IAppointmentDto";
import { AgendaStatus } from "../../models/enum/AgendaStatus";
import appointmentService from "../../services/agendaApi/appointment.service";
import '../../assets/css/views/agenda.css';
import { ISimpleMessageDto } from "../../models/dto/application/ISimpleMessageDto";
import BackButton from "../../features/path/backButton";
import { useNavigate } from "react-router-dom";
import { BreadCrumbsEnum } from "../../models/enum/BreadCrumbsEnum";
import Webcam from "react-webcam";
import LoaderModal from "../../components/Loader/loaderModal";
import productService from "../../services/generalApi/product.service";
import moment from "moment";
import checkInOutService from "../../services/generalApi/checkInOut.service";
import { useSelector } from "react-redux";
import { RootState } from "../../app/store";
import { ICheckInOutIn } from "../../models/input/generalApi/ICheckInOutIn";
import MapWithPolygon from "../../components/CheckInOut/mapWithPolygon";
import { useLocalization } from "../../hooks/checkInOutHooks/useLocalization";
import { useCamera } from "../../hooks/checkInOutHooks/useCamera";


interface ICommentDto {
  comment: string;
  typeCheck: string;
}

export default function Agendas() {

  const [t] = useTranslation("global");
  const navigate = useNavigate();
  const languageId: any = useSelector((state: RootState) => state.languageId);
  type SelectValue = number | string | boolean; //CHECK
  const [simpleMessage, setSimpleMessage] = useState<ISimpleMessageDto>({ showModal: false, modalMessage: '', modalTitle: '' });


  const [loadingData, setLoadingData] = useState(true);
  const [agendas, setAgendas] = useState<TableData[]>([]);

  const [agendaSelected, setAgendaSelected] = useState<IAppointmentDto | null>(null);
  const [comments, setComments] = useState<SelectOption[]>([]);
  const [comment, setComment] = useState<SelectValue[]>([]);
  const [tabCheckIn, setTabCheckIn] = useState<number>(0);


  const [showModalAgendaCheckIn, setShowModalAgendaCheckIn] = useState<boolean>(false);



  const {
    geolocationState,
    checkDistance,
    latlng
  } = useLocalization();


  const {
    webcamRef,
    imgSrc,
    setImgSrc,
    chargingPhoto,
    setChargingPhoto,
    photoSaved,
    setPhotoSaved,
    photoUrl,
    setPhotoUrl,
    photoError,
    setPhotoError,
    capture,
    cleanCapture
  } = useCamera('CheckIn/');



  useEffect(() => {
    getAgendas();

  }, [])


  const getAgendas = () => {
    setLoadingData(true);
    appointmentService.getAppointmentByUserCheckIn()
      .then((r: any) => {
        if (validateAgendaStatus(r[0])) {
          fillData(r);
        }
      }).finally(() => setLoadingData(false));
  }

  const getComments = async (subregionId: number) => {
    try {
      const response = await checkInOutService.getComments(subregionId, languageId.value, 'Check In');
      return response;
    } catch (error) {
      console.error(error);
    }
  }


  const fillComments = (data: ICommentDto[]) => {
    const commentsTemp: SelectOption[] = [];
    for (let i = 0; i < data.length; i++) {
      const comment: ICommentDto = data[i];
      let commentTemp: SelectOption;
      commentTemp = {
        'value': i,
        'label': comment.comment,
      }
      commentsTemp.push(commentTemp);
    }
    setComments(commentsTemp);
    setComment([commentsTemp[0].value])
  }


  const fillData = (data: IAppointmentDto[]) => {
    const pagedData: TableData[] = [];
    const activeAgenda = data.find(item => item.checkInDatetime !== null && item.checkOutDatetime === null);
    for (let i = 0; i < data.length; i++) {
      const agenda: IAppointmentDto = data[i];
      let tableData: TableData = {};
      tableData = {
        'status': <div id="outer-circle"><div id="inner-circle"></div></div>,
        'posCode': agenda.posCode,
        'pos': agenda.pos,
        'company': agenda.companyName,
        'scheduledTime': agenda.assignHourIn,
        'registeredTime': agenda.checkInDatetime == null ? t('header.notRegister') : agenda.checkInDatetime,
        'checkIn': <div>{(agenda.checkInDatetime !== null && agenda.checkOutDatetime !== null || activeAgenda?.appointmentId === agenda.appointmentId) ? <Button small onClick={() => handleActivitiesButton(agenda)} >{t("header.activities")}</Button> : <Button small onClick={() => handleCheckIn(agenda)} disabled={activeAgenda ? true : false}>{t("header.checkIn")}</Button>}</div>
      }
      pagedData.push(tableData);
    }
    setAgendas(pagedData);
  }



  const columns: TableColumns[] = [
    { id: 'status', label: '' },
    { id: 'posCode', label: t("header.posOfCode") },
    { id: 'pos', label: t("header.pos") },
    { id: 'company', label: t("header.company") },
    { id: 'scheduledTime', label: t("header.scheduledTime") },
    { id: 'registeredTime', label: t("header.registeredTime") },
    { id: 'checkIn', label: '' }
  ];

  const columnsWidth: TableColumnWidth[] = [
    { columnId: 'status', width: '10%' },
    { columnId: 'posCode', width: '20%' },
    { columnId: 'pos', width: '20%' },
    { columnId: 'company', width: '20%' },
    { columnId: 'scheduledTime', width: '10%' },
    { columnId: 'registeredTime', width: '10%' },
    { columnId: 'checkIn', width: '10%' }
  ]

  const tablePreferences: TablePreferences = {
    width: columnsWidth
  }

  const handleActivitiesButton = (agenda: IAppointmentDto) => {
    setAgendaSelected(agenda);
    navigate(`/activitiesByAppointment/${agenda.appointmentId}`, { state: { agendaSelected: agenda } });
  }

  const handleCloseCheckIn = () => {
    setShowModalAgendaCheckIn(false)
    cleanCapture();
    setComment([]);
    setComments([]);
    setTabCheckIn(0);
    setAgendaSelected(null);
  }

  const handleChangeComment = (value: SelectValue) => {
    setComment([value])
  }

  const handleCheckIn = (agenda: IAppointmentDto) => {
    getComments(agenda.subRegionId).then((res: ICommentDto[]) => {
      setAgendaSelected(agenda);
      fillComments(res);
    }).finally(() => setShowModalAgendaCheckIn(true));
  }

  const validateAgendaStatus = (data: IAppointmentDto): Boolean => {
    let showData: Boolean = false;
    if (data.userStatus === AgendaStatus.noAgendas) {
      setSimpleMessage({ showModal: true, modalMessage: t('header.noAgendas'), modalTitle: t('header.information') })
    } else if (data.userStatus === AgendaStatus.hasAbsence) {
      setSimpleMessage({ showModal: true, modalMessage: t('header.hasAbsences'), modalTitle: t('header.information') })
    } else {
      showData = true;
    }
    return showData;
  }


  const onCheckIn = () => {
    setChargingPhoto(true);
    let checkIn: ICheckInOutIn = {
      appointmentID: agendaSelected!.appointmentId,
      activityID: 1, //1 Check In - 5 Check Out
      longitude: latlng[1],
      latitude: latlng[0],
      checkStatus: 3,
      locPhoto: photoUrl!,
      photo: 'N/A',
      comments: String(comments.find(item => item.value === comment[0])?.label ?? t("header.comments"))
    };
    try {
      checkInOutService.postCheckInOut(checkIn)
        .then(r => {
          setChargingPhoto(false);
          setShowModalAgendaCheckIn(false);
          getAgendas();
          cleanCapture();
          setComment([]);
          setComments([]);
          setTabCheckIn(0);
          navigate(`/activitiesByAppointment/${checkIn.appointmentID}`, { state: { agendaSelected } });

        })

    } catch (error) {
      setShowModalAgendaCheckIn(false);
      setChargingPhoto(false);
      setTabCheckIn(0);

    }
  }




  return (

    <div>
      <div>
        {geolocationState === 2 ? (
          <div>
            <div style={{ padding: '20px' }}>
              <BackButton route={BreadCrumbsEnum.Agenda} />
              <h4>{t("header.agenda")}</h4>
              <div style={{ padding: '20px' }}>
                <Table
                  preferences={tablePreferences}
                  loading={loadingData}
                  columns={columns}
                  data={agendas}
                  css={{
                    height: '60vh'
                  }}
                  columnResize={true}
                />
              </div>
            </div>
            <SimpleMessageModal simpleMessage={simpleMessage}></SimpleMessageModal>

          </div>
        ) : (
          <div style={{ padding: '20px' }}>

            <IconWarning size={120} />
            <br />
            <b>{t("header.errorGeolocalization")}</b>

          </div>
        )}

      </div>


      <div style={{ position: 'relative' }}>
        <Modal
          className="modalAgendaCheckIn"
          align="center"
          id="modalAgendaCheckIn"
          show={showModalAgendaCheckIn}
          closeButton
          onClose={handleCloseCheckIn}
          footer={(() => {
            switch (tabCheckIn) {
              case 0:
                return <Button disabled={!photoSaved} onClick={() => setTabCheckIn(1)}>{t("header.next")}</Button>
                break;
              case 1:
                return <Button disabled={!photoSaved} onClick={() => onCheckIn()}>{t("header.checkIn")}</Button>
                break;
              default:
                <p>{t("header.error")}</p>
            }
          })()
          }
          title={t("header.checkIn")}
        >
          {agendaSelected && checkDistance(latlng[0], latlng[1], agendaSelected.latitude, agendaSelected.longitude) ?
            <div>
              {(() => {
                if (tabCheckIn === 0) {
                  return (<>
                    {chargingPhoto && <LoaderModal />}
                    {showModalAgendaCheckIn && (imgSrc ? <img src={imgSrc} alt="Captured" style={{ width: '100%', borderRadius: '12px' }} /> :
                      <Webcam audio={false} ref={webcamRef} style={{ width: '100%', borderRadius: '12px' }} />
                    )}
                    {photoError && <p style={{ color: 'red' }}>{t("header.error")}</p>}
                    <Button disabled={!photoSaved} onClick={cleanCapture} appearance="secondary" leadingIcon={<IconRestore />} style={{ marginRight: '2px' }} />
                    <Button disabled={photoSaved} onClick={capture} leadingIcon={<IconCamera />} />

                    <Select
                      className="modalAgendaCheckInSelect"
                      label={t("header.comments")}
                      onChange={e => handleChangeComment(e.value)}
                      options={comments}
                      value={comment}
                      clearIcon={false}
                    />
                  </>

                  )
                }
                else if (tabCheckIn === 1) {
                  return (<div className="modalAgendaDivMap">
                    <MapWithPolygon latPoint={agendaSelected.latitude} lngPoint={agendaSelected.longitude} lat={latlng[0]} lng={latlng[1]} />
                  </div>)
                }

              })()}

            </div>
            :
            <div>
              {agendaSelected && <div className="modalAgendaDivMapError">
                <MapWithPolygon latPoint={agendaSelected.latitude} lngPoint={agendaSelected.longitude} lat={latlng[0]} lng={latlng[1]} />
              </div>}
              <IconWarning size={60} />
              <br />
              <b>{t("header.errorGeolocalizationDistance")}</b>
            </div>
          }
        </Modal>
      </div>


    </div>
  );
}